import React, { useEffect, useState } from 'react'
import NewLayout from '../../components/layouts/NewLayout'
import { CardLayout, Text, useMainContext, useWindowSize } from '../../modules/staking'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as LightSvg } from '../../assets/DeriX/otc/light.svg'
import { ReactComponent as DotVector } from '../../assets/DeriX/dot-vector.svg'
import WalletTransactionsHistory from './wallet-hist'
import P2PHistory from './p2p-hist'
import InternalTransferHistory from './internal-transfer-hist'
import AccountTransactionsHistory from './acctount-hist'
import OtcHistory from './otc-hist'
import Card from '../../components/common/Card'
import { BsArrowRight } from 'react-icons/bs'
import { CgChevronLeft } from 'react-icons/cg'
import SwapHistory from './swap-hist'

const SUB_NAVS = [
	{ title: 'otc-transactions-history', icon: 'otc-trans.png', href: '/transactions/otc' },
	{ title: 'wallet-transactions-history', icon: 'wallet-trans.png', href: '/transactions/wallet' },
	// { title: 'p2p-transactions-history', icon: 'p2p-trans.png', href: '/transactions/p2p' },
	// {
	// 	title: 'internal-transactions-history',
	// 	icon: 'internal-trans.png',
	// 	href: '/transactions/transfer',
	// },
	{ title: 'account-transactions-history', icon: 'log.png', href: '/transactions/accounts' },
	// { title: 'swap-transactions-history', icon: 'otc-trans.png', href: '/transactions/swap' },
]

const Transactions = () => {
	const {
		main: { theme },
	} = useMainContext()
	const { pathname } = useLocation()

	const initialActiveLinkIndex = () => {
		switch (pathname) {
			case '/transactions':
				return 0
			case '/transactions/otc':
				return 1
			case '/transactions/wallet':
				return 2
			case '/transactions/p2p':
				return 3
			case '/transactions/transfer':
				return 4
			case '/transactions/accounts':
				return 5
			case '/transactions/swap':
				return 6
			default:
				return 0
		}
	}
	const [activeLinkIndex, setActiveLinkIndex] = useState(initialActiveLinkIndex)

	useEffect(() => {
		switch (pathname) {
			case '/transactions':
				setActiveLinkIndex(0)
				break
			case '/transactions/otc':
				setActiveLinkIndex(1)
				break
			case '/transactions/wallet':
				setActiveLinkIndex(2)
				break
			case '/transactions/p2p':
				setActiveLinkIndex(3)
				break
			case '/transactions/transfer':
				setActiveLinkIndex(4)
				break
			case '/transactions/accounts':
				setActiveLinkIndex(5)
				break
			case '/transactions/swap':
				setActiveLinkIndex(6)
				break
			default:
				setActiveLinkIndex(0)
		}
	}, [pathname])

	const Subpages = [
		OtcHistory,
		WalletTransactionsHistory,
		P2PHistory,
		InternalTransferHistory,
		AccountTransactionsHistory,
		SwapHistory,
	]
	let ActiveSubpage = Subpages[activeLinkIndex - 1]

	return (
		<NewLayout>
			<CardLayout>
				{activeLinkIndex === 0 ? (
					<div className='grid grid-cols-1 md:grid-cols-2 gap-3 w-full mx-auto max-w-lg lg:max-w-screen-lg'>
						{SUB_NAVS.map((page, index) => {
							return (
								<Link
									key={index}
									to={page.href}
									onClick={setActiveLinkIndex.bind(null, index)}
									className='relative hover:opacity-80'
								>
									<div className='relative overflow-hidden flex flex-col gap-2 items-center justify-center p-6 rounded-xl bg-white dark:bg-[#18191D]'>
										{theme === 'dark' ? (
											<>
												<div className={'absolute top-0 left-1/2 -translate-x-1/2 rounded-full'}>
													<LightSvg />
												</div>

												<div
													style={{
														background: `radial-gradient(50% 50% at 50% 50%, rgba(94, 148, 255, 0.24) 0%, rgba(49, 94, 255, 0) 100%)`,
													}}
													className={
														'opacity-60 absolute z-[5] left-1/2 -translate-x-1/2 top-[-20px] w-[150px] h-[150px]'
													}
												></div>
											</>
										) : null}
										<div className='flex items-center gap-2'>
											<DotVector />
											<img src={require(`./assets/${page.icon}`)} width={92} height={72} alt='' />
											<DotVector />
										</div>
										<Text tid={page.title} />
									</div>
								</Link>
							)
						})}
					</div>
				) : (
					<Card>
						<div className='grid grid-cols-1 gap-5 p-4'>
							<div className='flex gap-2 items-center'>
								<Link
									to={'/transactions'}
									className='flex items-center gap-2'
									onClick={setActiveLinkIndex.bind(null, 0)}
								>
									<Text tid={'transactions'} className='text-sm lg:text-base' />
								</Link>
								<CgChevronLeft />
								<Text tid={SUB_NAVS[activeLinkIndex - 1].title} className=' lg:text-xl ' />
							</div>
							<ActiveSubpage />
						</div>
					</Card>
				)}
			</CardLayout>
		</NewLayout>
	)
}

export default Transactions
